import { createTheme } from '@mui/material/styles';

import { customColors } from './types/themeColors';

const fontFamily = [
  'NewTheinhardt',
  'Theinhardt',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(',');

export const getTheme = () => {
  return createTheme({
    typography: {
      fontFamily,
      // H1 is what we call Heading in Nora
      h1: {
        fontSize: '32px',
        lineHeight: '40px',
        fontWeight: 500,
        fontFeatureSettings: `'cpsp' on`,
        textTransform: 'none',
      },
      // H2 is what we call Title Large in Nora
      h2: {
        fontSize: '22px',
        lineHeight: '28px',
        fontWeight: 500,
        fontFeatureSettings: `'case' on`,
        textTransform: 'none',
      },
      // H3 is what we call Title Small in Nora
      h3: {
        fontSize: '17px',
        lineHeight: '22px',
        fontWeight: 500,
        fontFeatureSettings: `'case' on`,
        textTransform: 'none',
      },
      // BodyMBold is what we call Body Bold in Nora
      bodyMBold: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 700,
        fontFeatureSettings: `'case' on`,
        textTransform: 'none',
        letterSpacing: '0.003em',
      },
      bodyLMed: {
        fontSize: '18px',
        lineHeight: '26px',
        fontWeight: 500,
        fontFeatureSettings: `'case' on`,
        textTransform: 'none',
        letterSpacing: '0.003em',
      },
      // Body1 is what we call Body Bold in Nora
      body1: {
        fontSize: '15px',
        lineHeight: '20px',
        fontWeight: 500,
        fontFeatureSettings: `'case' on`,
        textTransform: 'none',
        letterSpacing: '0.003em',
      },
      // Body is what we call Body Bold in Nora
      body2: {
        fontSize: '15px',
        lineHeight: '20px',
        fontWeight: 400,
        fontFeatureSettings: `'case' on`,
        textTransform: 'none',
        letterSpacing: '0.003em',
      },
      displaySBold: {
        fontSize: '20px',
        lineHeight: '28px',
        fontWeight: 700,
        fontFeatureSettings: `'case' on`,
        textTransform: 'none',
        letterSpacing: '0.015em',
      },
      // Subtitle1 is what we call Small Bold in Nora
      subtitle1: {
        fontSize: '13px',
        lineHeight: '16px',
        fontWeight: 500,
        fontFeatureSettings: `'case' on`,
        textTransform: 'none',
        letterSpacing: '0.015em',
      },
      // Subtitle2 is what we call Small Bold in Nora
      subtitle2: {
        fontSize: '13px',
        lineHeight: '16px',
        fontWeight: 400,
        fontFeatureSettings: `'case' on`,
        letterSpacing: '0.015em',
        textTransform: 'none',
      },
      // Overline is what we call Section in Nora
      overline: {
        fontSize: '11px',
        lineHeight: '16px',
        fontWeight: 500,
        fontFeatureSettings: `'case' on`,
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
      },
    },

    palette: {
      text: {
        // Blue 400
        primary: '#0D1F40',
        // Blue 100
        secondary: '#7C8699',
      },
      background: {
        default: '#FFFFFF',
      },
      primary: {
        // Green 400
        main: '#007AFF',
        // Green 100
        light: '#DEEEFF',
      },
      secondary: {
        main: '#34C759',
        light: '#E5F8EA',
      },
    },
    shape: {
      borderRadius: 3,
    },
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: '13px',
            lineHeight: '16px',
            fontWeight: 400,
            letterSpacing: '0.015em',
            textTransform: 'none',
            color: 'white',
            backgroundColor: '#0D1F40',
            padding: '0.5em 1em 0.4em 1em',
          },
          arrow: {
            color: '#0D1F40',
          },
        },
      },
    },
    customColors,
  });
};
